module.exports = __webpack_public_path__ + "img/reserve-active.defb5afd.png";